export enum AutoBetStopReason {
  INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
  MAX_BETS_REACHED = 'MAX_BETS_REACHED',
  PROFIT_TARGET_REACHED = 'PROFIT_TARGET_REACHED',
  STOP_LOSS_REACHED = 'STOP_LOSS_REACHED',
}
